import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Reduce a route to a path that is safe to send to GoatCounter.
 * Query strings and hashes are always dropped (e.g., OAuth codes on /reg/health_callback).
 * - /reg/<page>/<projectId>/...  -> /reg/<page>/<projectId>   (drops pId / code segments)
 * - /admin/<section>/...         -> /admin/<section>          (drops participant/project IDs)
 * - /user/...                    -> unchanged (no IDs in these routes)
 */
export function sanitizePath(pathname) {
  const parts = pathname.split("/").filter(Boolean);
  if (parts[0] === "reg") return "/" + parts.slice(0, 3).join("/");
  if (parts[0] === "admin") return "/" + parts.slice(0, 2).join("/");
  return "/" + parts.join("/");
}

/** Counts a GoatCounter page view on every route change (script loads with no_onload). */
export default function GoatCounterTracker() {
  const location = useLocation();

  useEffect(() => {
    const path = sanitizePath(location.pathname);
    let tries = 0;
    let timer;
    const send = () => {
      if (window.goatcounter && window.goatcounter.count) {
        window.goatcounter.count({ path });
      } else if (tries++ < 20) {
        // count.js loads async; wait for it on the first page view
        timer = setTimeout(send, 250);
      }
    };
    send();
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return null;
}
